export const SET_ROLES = 'SET_ROLES';
export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_ROLES_PERMISSIONS = 'SET_ROLES_PERMISSIONS';
export const SET_ALL_PERMISSIONS = 'SET_ALL_PERMISSIONS';
